import { render, staticRenderFns } from "./take-family-member-pulse.vue?vue&type=template&id=70896315&"
import script from "./take-family-member-pulse.vue?vue&type=script&lang=js&"
export * from "./take-family-member-pulse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports